import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { signOut } from 'firebase/auth';
import { auth, db } from '../firebase';
import './MyApplications.css';

function MyApplications() {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const user = auth.currentUser;

  useEffect(() => {
    fetchMyApplications();
  }, []);

  const fetchMyApplications = async () => {
    try {
      const q = query(
        collection(db, 'applications'),
        where('userId', '==', user.uid)
      );
      
      const querySnapshot = await getDocs(q);
      const apps = [];
      querySnapshot.forEach((doc) => {
        apps.push({ id: doc.id, ...doc.data() });
      });
      
      apps.sort((a, b) => {
        if (a.createdAt && b.createdAt) {
          return b.createdAt.toMillis() - a.createdAt.toMillis();
        }
        return 0;
      });
      
      setApplications(apps);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching applications:', error);
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  const handleSubmitFeedback = (app) => {
    navigate('/feedback', {
      state: {
        productId: app.productId,
        productName: app.productName,
        applicationId: app.id
      }
    });
  };

  if (loading) {
    return (
      <div className="my-applications">
        <nav className="apps-nav">
          <div className="nav-container">
            <div className="logo">BetaBuyers</div>
            <button onClick={handleLogout} className="btn-logout">Sign Out</button>
          </div>
        </nav>
        <div className="apps-content">
          <div className="loading">Loading your applications...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="my-applications">
      <nav className="apps-nav">
        <div className="nav-container">
          <div className="logo">BetaBuyers</div>
          <div className="nav-buttons">
            <button onClick={() => navigate('/dashboard')} className="btn-nav">Dashboard</button>
            <button onClick={handleLogout} className="btn-logout">Sign Out</button>
          </div>
        </div>
      </nav>

      <div className="apps-content">
        <div className="apps-header">
          <h1>My Applications</h1>
          <p>Track your application status and submit feedback for approved products</p>
        </div>

        {applications.length === 0 ? (
          <div className="no-apps">
            <p>You haven't submitted any applications yet.</p>
            <button onClick={() => navigate('/apply')} className="btn-apply-now">
              Apply Now
            </button>
          </div>
        ) : (
          <div className="apps-grid">
            {applications.map(app => (
              <div key={app.id} className="app-card">
                <div className="app-header">
                  <h3>{app.productName || 'Product'}</h3>
                  <span className={`status-badge ${app.status}`}>
                    {app.status}
                  </span>
                </div>
                
                <div className="app-details">
                  <div className="app-field">
                    <strong>Submitted:</strong>
                    <p>{app.createdAt ? new Date(app.createdAt.toMillis()).toLocaleDateString() : 'N/A'}</p>
                  </div>
                  
                  <div className="app-field">
                    <strong>Why you want to test:</strong>
                    <p>{app.reason}</p>
                  </div>
                  
                  <div className="app-field">
                    <strong>Your experience:</strong>
                    <p>{app.experience}</p>
                  </div>
                  
                  {app.contact && (
                    <div className="app-field">
                      <strong>Contact:</strong>
                      <p>{app.contact}</p>
                    </div>
                  )}
                </div>

                {app.status === 'approved' && (
                  <div className="feedback-action">
                    <button 
                      onClick={() => handleSubmitFeedback(app)}
                      className="btn-submit-feedback"
                    >
                      Submit Feedback
                    </button>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default MyApplications;